import { useGameStore } from './store/gameStore';
import Board2D from './components/board/Board2D';
import ModernGameUI from './components/game/ModernGameUI';
import Lobby from './components/Lobby';
import './styles/App.css';

export default function App() {
  const { isConnected, gameId } = useGameStore();

  // ゲームに接続していない場合はロビー表示
  if (!gameId || !isConnected) {
    return <Lobby />;
  }

  // ゲーム画面
  return (
    <div className="app">
      <Board2D />
      <ModernGameUI />
    </div>
  );
}
